import { ActionSlot, Game, InfiniteCardPile, Player } from "~/business";
import {
  DefInstance,
  EntityRepository,
  Pile,
  ResourcePile,
  Resources,
  Serializer,
} from "~/utils";

export const gameSerializer = () =>
  new Serializer({
    Game,
    Player,
    Pile,
    DefInstance,
    ResourcePile,
    Resources,
    EntityRepository,
    InfiniteCardPile,
    ActionSlot,
  });
